export default __webpack_public_path__ + "static/media/image.6d900ecd.png";